import {
  useSortable,
} from '@dnd-kit/sortable';
import { MenuOutlined } from "@ant-design/icons";

import CardContent from "@/components/card/CardContent";

import { CSS } from '@dnd-kit/utilities';

import './styles/series-order-item.scss'

function SeriesOrderItem({ id, text, index, order, item }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    cursor: 'grab',
    userSelect: 'none',
  };

  return (
    <div ref={setNodeRef} className="sort-order-item" style={style} {...attributes} {...listeners}>
      <CardContent isPaddingTop={true}>
        <div className="sort-order-item__container">
          <div className='sort-order-item__container__left'>
            <MenuOutlined />
          </div>

          <div className="sort-order-item__container__right">
            <span className="sort-order-item__index">{ index + 1 }.</span>
            <span className="sort-order-item__text">Серия: "{item.film_name}"</span>
            {/* <span className='sort-order-item__position-old'>{ order }</span> */}
          </div>
        </div>
      </CardContent>
    </div>
  );
}

export default SeriesOrderItem